import React from 'react';
import md5 from 'md5';
import { Flex } from 'grid-styled';
import { Box } from 'grid-styled';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import { ButtonImage } from '../styledSystem/Image';
import Button from './Button';
import { Input } from '../styledSystem/Input';
import Select from './Select';
import { HR } from '../uic/HorizontalLine';
import Background from '../assets/alert-circle.png';
import session from '../session';

export default class Upload extends React.Component {
    state = {
        changeinprogress: false,
        userchanging: 'admin',
        erroruser: false,
        errorcurrentpassword: '',
        errornewpassword: '',
        errorrepeatpassword: '',
        hovercurrentPassword: false,
        hovernewPassword: false,
        hoverrepeatPassword: false,
        sucessmessage: false,
        error401message: false,
        errormessage: false
    };

    handleMouseIn(event) {
        let hovervariable = 'hover' + event.target.id;
        this.setState({ [hovervariable]: true });
    }

    handleMouseOut(event) {
        let hovervariable = 'hover' + event.target.id;
        this.setState({ [hovervariable]: false });
    }

    updateState = uservalue => {
        this.setState({ userchanging: uservalue });
    };

    changeIcecastPassword = async () => {
        console.log('changeIcecastPassword: start');
        try {
            this.setState({ changeinprogress: true });

            let newPassword = document.querySelector('#newPassword').value;
            let currentPassword = document.querySelector('#currentPassword')
                .value;

            console.log(
                'changeIcecastPassword currentPassword:' + currentPassword
            );
            console.log('changeIcecastPassword newPassword:' + newPassword);

            const data = {
                currentPassword: currentPassword,
                newPassword: newPassword
            };

            const url = `/cgi/icecast.cgi?oldpass=${encodeURIComponent(
                data.currentPassword
            )}&icepass=${encodeURIComponent(data.newPassword)}`;

            console.log('changeIcecastPassword url=>' + url);

            let result = await this.props.session.realm.fetch(url, {
                method: 'GET'
            });
            var obj = JSON.parse(result);
            console.log(obj);

            if (obj.error === '1') {
                // error due wrong password
                this.setState({
                    errormessage: true,
                    sucessmessage: false
                });
            } else {
                // success
                this.setState({
                    errormessage: false,
                    sucessmessage: true
                });
            }
        } catch (err) {
            console.error('changeIcecastPassword:' + err);
        }
        console.log('changeIcecastPassword: end');
    };

    savePassword = async () => {
        try {
            if (this.state.userchanging === 'icecast') {
                this.changeIcecastPassword();

                return;
            }

            let currentPassword = document.querySelector('#currentPassword')
                .value;
            let newPassword = document.querySelector('#newPassword').value;

            this.validateUser();
            const validPass = this.validatePasswords();

            if (validPass) {
                this.setState({ changeinprogress: true });
                const nonce = await session.rpc('call', [
                    '',
                    'login',
                    'nonce_get',
                    {}
                ]);

                let realm = 'Barix Login';
                let role = this.state.userchanging;
                let pass = currentPassword;
                const hashPassword = md5(role + ':' + realm + ':' + pass);
                const hashPasswordNonce = md5(
                    role +
                        ':' +
                        realm +
                        ':' +
                        hashPassword +
                        ':' +
                        nonce[1].nonce
                );
                const hashNewPassword = md5(
                    role + ':' + realm + ':' + newPassword
                );

                const result = await session.rpc('call', [
                    '',
                    'login',
                    'passwd_change',
                    {
                        user: role,
                        hash: hashPasswordNonce,
                        nhash: hashNewPassword
                    }
                ]);

                if (result[1].status === '200 OK') {
                    this.setState({
                        sucessmessage: true,
                        changeinprogress: false
                    });
                    session.logout();
                } else if (result[1].status === '401 Access denied') {
                    this.setState({
                        error401message: true,
                        changeinprogress: false
                    });
                } else {
                    this.setState({
                        errormessage: true,
                        changeinprogress: false
                    });
                }
            }
        } catch (err) {
            console.error('savePassword:' + err);
        }
    };

    validateUser = () => {
        if (this.state.userchanging === '') {
            this.setState({ erroruser: true });
        } else {
            this.setState({ erroruser: false });
        }
    };

    validatePasswords = () => {
        let currentPassword = document.querySelector('#currentPassword').value;
        let newPassword = document.querySelector('#newPassword').value;
        let repeatPassword = document.querySelector('#repeatPassword').value;

        let errorCount = 0;

        if (
            currentPassword !== '' &&
            newPassword !== '' &&
            repeatPassword !== ''
        ) {
            this.setState({
                errornewpassword: '',
                errorrepeatpassword: '',
                errorcurrentpassword: ''
            });
            if (newPassword !== repeatPassword) {
                this.setState({
                    errornewpassword: 'Passwords do not match',
                    errorrepeatpassword: 'Passwords do not match'
                });

                errorCount++;
            }
        } else {
            if (currentPassword === '') {
                this.setState({
                    errorcurrentpassword: 'Current password cannot be empty'
                });

                errorCount++;
            } else {
                this.setState({
                    errorcurrentpassword: ''
                });
            }

            if (newPassword === '') {
                this.setState({
                    errornewpassword: 'New password cannot be empty'
                });

                errorCount++;
            } else {
                this.setState({
                    errornewpassword: ''
                });
            }

            if (repeatPassword === '') {
                this.setState({
                    errorrepeatpassword: 'Repeat new password cannot be empty'
                });

                errorCount++;
            } else {
                this.setState({
                    errorrepeatpassword: ''
                });
            }
        }
        if (errorCount > 0) {
            return false;
        } else {
            return true;
        }
    };

    render() {
        const tooltipStyleNewPassword = {
            display: this.state.hovernewPassword ? 'block' : 'none',
            position: 'absolute',
            right: 0,
            margin: 0,
            top: '5px',
            backgroundColor: '#c1272d',
            width: '70%',
            padding: '5px'
        };

        const tooltipStyleCurrentPassword = {
            display: this.state.hovercurrentPassword ? 'block' : 'none',
            position: 'absolute',
            right: 0,
            margin: 0,
            top: '5px',
            backgroundColor: '#c1272d',
            width: '70%',
            padding: '5px'
        };

        const tooltipStyleRepeatPassword = {
            display: this.state.hoverrepeatPassword ? 'block' : 'none',
            position: 'absolute',
            right: 0,
            margin: 0,
            top: '5px',
            backgroundColor: '#c1272d',
            width: '70%',
            padding: '5px'
        };

        return (
            <Box>
                <BoxTemplate height="15px" />
                {this.state.sucessmessage ? (
                    <Box mt={'40px'} mb={'40px'}>
                        <ButtonImage
                            src={require('../assets/check_black.png')}
                            alt="check"
                            height="25"
                            width="auto"
                        />
                        <Label textStyle="labelBold" textransform="uppercase">
                            New password successfully saved
                        </Label>
                    </Box>
                ) : this.state.error401message ? (
                    <Box mt={'40px'} mb={'40px'}>
                        <ButtonImage
                            src={require('../assets/alert.png')}
                            alt="alert"
                            height="25"
                            width="auto"
                        />
                        <Label
                            textStyle="labelBold"
                            color="dangerRed"
                            textransform="uppercase"
                        >
                            Access error
                        </Label>
                        <br />
                        <Label textStyle="labelSmall" color="dangerRed">
                            The given current password is wrong.
                        </Label>
                    </Box>
                ) : this.state.errormessage ? (
                    <Box mt={'40px'} mb={'40px'}>
                        <ButtonImage
                            src={require('../assets/alert.png')}
                            alt="alert"
                            height="25"
                            width="auto"
                        />
                        <Label
                            textStyle="labelBold"
                            color="dangerRed"
                            textransform="uppercase"
                        >
                            Error
                        </Label>
                        <br />
                        <Label textStyle="labelSmall" color="dangerRed">
                            Server error
                        </Label>
                    </Box>
                ) : (
                    <div>
                        <BoxTemplate textalign="left" mt={'5px'} mb={'20px'}>
                            <Select
                                label="Choose the user"
                                updateState={this.updateState}
                                background={Background}
                                statevariable={this.state}
                                errormask={this.state.erroruser}
                                optionsValue={['admin', 'user', 'icecast']}
                                optionsName={['admin', 'user', 'Icecast admin']}
                                onChange={this.validateUser}
                            />
                            <HR height="2px" />
                            <Box w={1}>
                                <BoxTemplate
                                    display="inline-block"
                                    textalign="left"
                                    w={1 / 2}
                                >
                                    <Label textStyle="labelNormal">
                                        Current Password
                                    </Label>
                                </BoxTemplate>
                                <BoxTemplate display="inline-block" w={1 / 2}>
                                    <div
                                        onMouseOver={this.handleMouseIn.bind(
                                            this
                                        )}
                                        onMouseOut={this.handleMouseOut.bind(
                                            this
                                        )}
                                    >
                                        <Input
                                            errormask={
                                                this.state.errorcurrentpassword
                                                    ? true
                                                    : false
                                            }
                                            background={Background}
                                            id="currentPassword"
                                            type="password"
                                            onChange={this.validatePasswords}
                                        />
                                    </div>
                                    {this.state.errorcurrentpassword !== '' && (
                                        <BoxTemplate position="relative">
                                            <BoxTemplate
                                                style={
                                                    tooltipStyleCurrentPassword
                                                }
                                            >
                                                <Label
                                                    color="white"
                                                    textStyle="labelSmall"
                                                >
                                                    {
                                                        this.state
                                                            .errorcurrentpassword
                                                    }
                                                </Label>
                                            </BoxTemplate>
                                        </BoxTemplate>
                                    )}
                                </BoxTemplate>
                            </Box>
                            <Box w={1}>
                                <BoxTemplate
                                    display="inline-block"
                                    textalign="left"
                                    w={1 / 2}
                                >
                                    <Label textStyle="labelNormal">
                                        New Password
                                    </Label>
                                </BoxTemplate>
                                <BoxTemplate display="inline-block" w={1 / 2}>
                                    <div
                                        onMouseOver={this.handleMouseIn.bind(
                                            this
                                        )}
                                        onMouseOut={this.handleMouseOut.bind(
                                            this
                                        )}
                                    >
                                        <Input
                                            errormask={
                                                this.state.errornewpassword
                                                    ? true
                                                    : false
                                            }
                                            background={Background}
                                            id="newPassword"
                                            type="password"
                                            onChange={this.validatePasswords}
                                        />
                                    </div>
                                    {this.state.errornewpassword !== '' && (
                                        <BoxTemplate position="relative">
                                            <BoxTemplate
                                                style={tooltipStyleNewPassword}
                                            >
                                                <Label
                                                    color="white"
                                                    textStyle="labelSmall"
                                                >
                                                    {
                                                        this.state
                                                            .errornewpassword
                                                    }
                                                </Label>
                                            </BoxTemplate>
                                        </BoxTemplate>
                                    )}
                                </BoxTemplate>
                            </Box>
                            <Box w={1}>
                                <BoxTemplate
                                    display="inline-block"
                                    textalign="left"
                                    w={1 / 2}
                                >
                                    <Label textStyle="labelNormal">
                                        Repeat New Password
                                    </Label>
                                </BoxTemplate>
                                <BoxTemplate display="inline-block" w={1 / 2}>
                                    <div
                                        onMouseOver={this.handleMouseIn.bind(
                                            this
                                        )}
                                        onMouseOut={this.handleMouseOut.bind(
                                            this
                                        )}
                                    >
                                        <Input
                                            errormask={
                                                this.state.errorrepeatpassword
                                                    ? true
                                                    : false
                                            }
                                            background={Background}
                                            id="repeatPassword"
                                            type="password"
                                            onChange={this.validatePasswords}
                                        />
                                    </div>
                                    {this.state.errorrepeatpassword !== '' && (
                                        <BoxTemplate position="relative">
                                            <BoxTemplate
                                                style={
                                                    tooltipStyleRepeatPassword
                                                }
                                            >
                                                <Label
                                                    color="white"
                                                    textStyle="labelSmall"
                                                >
                                                    {
                                                        this.state
                                                            .errorrepeatpassword
                                                    }
                                                </Label>
                                            </BoxTemplate>
                                        </BoxTemplate>
                                    )}
                                </BoxTemplate>
                            </Box>
                        </BoxTemplate>

                        <Flex>
                            <Button onClick={this.props.close} icon="close">
                                Cancel
                            </Button>
                            <Button
                                icon="check"
                                onClick={this.savePassword}
                                busy={this.state.changeinprogress}
                            >
                                Save Password
                            </Button>
                        </Flex>
                    </div>
                )}
            </Box>
        );
    }
}



// WEBPACK FOOTER //
// ./src/uic/ManagePassword.js